import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Helper from "../../helper";
import Appconfig from "../../config/config";
import axios from "axios";
import { toast } from "react-toastify";
import "./ScrollGames.css";
import Login from "../Login/Login";

const MOBILE_NAVIGATION_ITEMS = [
  {
    id: "inplay",
    label: "In Play",
    image: "in-play.png",
    eventType: "In-Play",
  },
  {
    id: "cricket",
    label: "Cricket",
    image: "4.png",
    eventType: 4,
  },
  {
    id: "football",
    label: "Football",
    image: "1.png",
    eventType: 1,
  },
  {
    id: "tennis",
    label: "Tennis",
    image: "2.png",
    eventType: 2,
  },
  {
    id: "fantasy11",
    label: "Fantasy 11",
    image: "979797.svg",
    requireLogin: true,
  },
  {
    id: "cock-fight",
    label: "Cock Fight",
    image: "969696.png",
    requireLogin: true,
  },
  {
    id: "politics",
    label: "Politics",
    image: "2378961.png",
    requireLogin: true,
  },
  {
    id: "casino",
    label: "Casino",
    image: "99998.png",
    requireLogin: true,
  },
  {
    id: "sports-book",
    label: "Sports Book",
    image: "99991.png",
    requireLogin: true,
  },
  {
    id: "horse-racing",
    label: "Horse Racing",
    image: "7.png",
    requireLogin: true,
  },
  {
    id: "greyhound-racing",
    label: "Greyhound Racing",
    image: "4339.png",
    requireLogin: true,
  },
  {
    id: "others",
    label: "others",
    image: "100000.png",
    requireLogin: true,
  },
  {
    id: "binary",
    label: "Binary",
    image: "99990.png",
    requireLogin: true,
  },
  {
    id: "basketball",
    label: "Basketball",
    image: "7522.png",
    requireLogin: true,
  },
  {
    id: "baseball",
    label: "Baseball",
    image: "7511.png",
    requireLogin: true,
  },
  {
    id: "table-tennis",
    label: "Table Tennis",
    image: "20.png",
    requireLogin: true,
  },
  {
    id: "volleyball",
    label: "Volleyball",
    image: "998917.png",
    requireLogin: true,
  },
  {
    id: "ice-hockey",
    label: "Ice Hockey",
    image: "7524.png",
    requireLogin: true,
  },
  {
    id: "rugby",
    label: "Rubgy",
    image: "5.png",
    requireLogin: true,
  },
  {
    id: "mma",
    label: "Mixed Martial Arts",
    image: "26420387.png",
    requireLogin: true,
  },
  {
    id: "darts",
    label: "Darts",
    image: "3503.png",
    requireLogin: true,
  },
  {
    id: "futsal",
    label: "Futsal",
    image: "29.png",
    requireLogin: true,
  },
  {
    id: "genius",
    label: "Genius",
    image: "99989.png",
    requireLogin: true,
  },
  {
    id: "predix",
    label: "Predix",
    image: "989898.png",
    requireLogin: true,
  },
];

const ScrollGames = (props) => {
  const navigate = useNavigate();
  const userInfo = Helper();

  const [activeMenu, setActiveMenu] = useState("crash");

  const [activeSport, setActiveSport] = useState(props.eventType ?? 4);
  const [activeNavigation, setActiveNavigation] = useState("inplay");
  const [showLoginPopup, setShowLoginPopup] = useState(false);

  function CreateAndLaunchWCOCasino(provider_code, game_code, type = null) {
    const userData = {
      user_id: userInfo?._id,
      user_name: userInfo?.user_name,
      redirect_url: "https://daddyexch.live/",
      provider_code: provider_code,
      game_code: game_code,
      type: type,
    };

    var config = {
      method: "post",
      url: `${Appconfig.casinoUrl}wco/login`,
      headers: {
        "Content-Type": "application/json",
      },

      data: JSON.stringify(userData),
    };

    axios(config)
      .then(function (response) {
        let status = response.data.status?.code;
        if (status === "SUCCESS") {
          window.open(response.data.launchURL, "_self");
        }

        if (status == "VALIDATION_ERROR" || status == "UNKNOWN_ERROR") {
          toast.error("Game Not Found.", { autoClose: 2000 });
        } else if (status == "AUTHENTICATION_FAILED") {
          toast.error(response.data.status?.message, { autoClose: 2000 });
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const runProtectedAction = (menuKey, action) => {
    setActiveMenu(menuKey);

    if (!userInfo?._id) {
      navigate("/login");
      return;
    }

    action();
  };

  const changeNavigation = (item) => {
    setActiveNavigation(item.id);

    if (item.requireLogin) {
      if (!userInfo?._id) {
        setShowLoginPopup(true);
        return;
      }

      navigate(item.path || "/dashboard");
      return;
    }

    if (item.eventType !== undefined) {
      setActiveSport(item.eventType);

      if (props.setEventType) {
        props.setEventType(item.eventType);
      }

      navigate(`/dashboard?sport=${item.eventType}`);
      return;
    }

    navigate(item.path || "/dashboard");
  };

  const casinoMenuGames = {
    crash: {
      providerCode: "SPB",
      gameCode: "avaitor",
    },

    lottery: {
      providerCode: "DC",
      gameCode: "150616",
      type: null,
    },

    sports: {
      providerCode: "BT",
      gameCode: "",
    },

    "our-casino": {
      providerCode: "DC",
      gameCode: "600000",
    },

    "live-casino": {
      providerCode: "DC",
      gameCode: "150000",
    },

    slots: {
      providerCode: "DC",
      gameCode: "902000",
    },

    fantasy: {
      providerCode: "QT",
      gameCode: "KAG-fantasypark",
    },
  };

  const launchCasinoMenuGame = (menuKey) => {
    const game = casinoMenuGames[menuKey];

    setActiveMenu(menuKey);

    if (!userInfo?._id) {
      navigate("/login");
      return;
    }

    if (!game?.providerCode) {
      console.error(`Casino configuration missing for ${menuKey}:`, game);

      toast.error("Casino configuration is missing.", {
        autoClose: 2000,
      });

      return;
    }

    CreateAndLaunchWCOCasino(
      game.providerCode,
      game.gameCode || "",
      game.type || null,
    );
  };

  return (
    <>
      <nav
        className="mobile-navigation-games"
        aria-label="Mobile game navigation"
      >
        {MOBILE_NAVIGATION_ITEMS.map((item) => (
          <button
            key={item.id}
            type="button"
            className={[
              "mobile-navigation-game",
              item.id === "fantasy11" ? "mobile-navigation-game-fantasy" : "",
              item.id === "predix" ? "mobile-navigation-game-predix" : "",
              activeNavigation === item.id ? "active" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            onClick={() => changeNavigation(item)}
          >
            {item.image ? (
              <img
                src={`${process.env.PUBLIC_URL}/Images/navigation-images/${item.image}`}
                alt=""
                aria-hidden="true"
              />
            ) : (
              <i
                className="fas fa-play-circle mobile-navigation-inplay-icon"
                aria-hidden="true"
              />
            )}

            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      {showLoginPopup && <Login onClose={() => setShowLoginPopup(false)} />}
    </>
  );
};

export default ScrollGames;
